module.exports = __webpack_public_path__ + "static/img/4156_phase_function_Paper_PointsHejduk_Prediction.cf41d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4156_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5Hb9
// module chunks = 0